"use client"

import React from "react"

import { useState } from "react"
import { Button } from "../../../components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog"
import { Input } from "../../../components/ui/input"
import { Label } from "../../../components/ui/label"
import { FolderPlus, ImagePlus, X } from "lucide-react"

interface AddSubcategoryModalProps {
  onAddSubcategory: (name: string, thumbnail?: string) => void
}

export function AddSubcategoryModal({ onAddSubcategory }: AddSubcategoryModalProps) {
  const [open, setOpen] = useState(false)
  const [name, setName] = useState("")
  const [thumbnail, setThumbnail] = useState<string | null>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    if (!file.type.startsWith("image/")) {
      alert("Por favor, selecione apenas arquivos de imagem.")
      return
    }

    const reader = new FileReader()
    reader.onload = (event) => {
      setThumbnail(event.target?.result as string)
    }
    reader.readAsDataURL(file)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (name.trim()) {
      onAddSubcategory(name.trim(), thumbnail || undefined)
      setName("")
      setThumbnail(null)
      setOpen(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="gap-2">
          <FolderPlus className="h-4 w-4" />
          Nova Subcategoria
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Adicionar Subcategoria</DialogTitle>
            <DialogDescription>
              Crie uma subcategoria para organizar os projetos dentro desta categoria.
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="subcategory-name">Nome da Subcategoria</Label>
              <Input
                id="subcategory-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ex: Times Estaduais, Linha Feminina..."
                autoFocus
              />
            </div>

            <div className="grid gap-2">
              <Label>Thumbnail (opcional)</Label>

              {thumbnail ? (
                <div className="relative w-full max-w-[160px]">
                  <img
                    src={thumbnail}
                    alt="Thumbnail da subcategoria"
                    className="w-full aspect-video object-cover rounded-lg border"
                  />
                  <Button
                    type="button"
                    variant="destructive"
                    size="icon"
                    className="absolute -top-2 -right-2 h-6 w-6 rounded-full p-0"
                    onClick={() => setThumbnail(null)}
                  >
                    <X className="h-3 w-3" />
                  </Button>
                </div>
              ) : (
                <label className="flex flex-col items-center justify-center gap-1 w-full max-w-[160px] aspect-video rounded-lg border-2 border-dashed border-border hover:border-primary cursor-pointer transition-all bg-secondary/20 hover:bg-secondary/40">
                  <ImagePlus className="h-5 w-5 text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">Escolher imagem</span>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="hidden"
                  />
                </label>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => setOpen(false)}>
              Cancelar
            </Button>
            <Button type="submit" disabled={!name.trim()}>
              Adicionar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
